module.exports = __webpack_public_path__ + "img/icon_map_1_5_c.c9d5f9f9.png";